'use es6';

import I18n from 'I18n';
import PropTypes from 'prop-types';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import KeyboardBackend, { isKeyboardDragTrigger } from '../vendor/react-dnd-accessible-backend@1.0.1';
import { MultiBackend, createTransition, MouseTransition } from '../vendor/react-dnd-multi-backend@8.0.0';
import { useMemo } from 'react';

/**
 * At the moment, the keybinds used for drag and drop are hard-coded as:
 *  - ctrl+d (command+d on macOS) to pick up a draggable item
 *  - up and down arrow keys to move between drop targets
 *  - Enter or Spacebar to drop the dragged item on a drop target
 *  - Escape while dragging to cancel the drag operation
 */
import { jsx as _jsx } from "react/jsx-runtime";
const KeyboardTransition = createTransition('keydown', event => {
  if (!isKeyboardDragTrigger(event)) return false;
  event.preventDefault();
  return true;
});
function getNodeDescription(node) {
  if (node == null) return undefined;
  return node.getAttribute('data-dnd-name') || node.getAttribute('aria-label') || node.textContent;
}
function getCustomAnnouncementMessages() {
  return {
    pickedUpItem: (item, node) => I18n.text('DraggableProvider.pickedUpItem', {
      item: getNodeDescription(node)
    }),
    droppedItem: (item, node) => I18n.text('DraggableProvider.droppedItem', {
      item: getNodeDescription(node)
    }),
    hoveredTarget: (item, node) => I18n.text('DraggableProvider.hoveredTarget', {
      item: getNodeDescription(node)
    }),
    canceledDrag: () => I18n.text('DraggableProvider.canceledDrag')
  };
}
const DraggableProvider = ({
  children,
  keyBoardBackendOptions = {}
}) => {
  const dndOptions = useMemo(() => {
    return {
      backends: [{
        id: 'html5',
        backend: HTML5Backend,
        options: {
          getAnnouncementMessages: getCustomAnnouncementMessages
        },
        transition: MouseTransition
      }, {
        id: 'keyboard',
        backend: KeyboardBackend.default,
        context: {
          window,
          document
        },
        options: Object.assign({
          preview: true,
          getAnnouncementMessages: getCustomAnnouncementMessages
        }, keyBoardBackendOptions),
        transition: KeyboardTransition
      }]
    };
  }, [keyBoardBackendOptions]);
  return /*#__PURE__*/_jsx(DndProvider, {
    backend: MultiBackend,
    options: dndOptions,
    children: children
  });
};
DraggableProvider.propTypes = {
  children: PropTypes.node.isRequired,
  keyBoardBackendOptions: PropTypes.object
};
export default DraggableProvider;